import firebase from 'firebase';


export const initializeFirbase = () => {
    const config = {
        apiKey: 'AIzaSyBFpZLmMbsbPtaPsuGKMMS7LrRdFggzB8I',
        authDomain: 'irimo-9becf.firebaseapp.com',
        databaseURL: 'https://irimo-9becf.firebaseio.com',
        projectId: 'irimo-9becf',
        storageBucket: 'irimo-9becf.appspot.com',
        messagingSenderId: '973940814344',
        appId: '1:973940814344:web:843fef74099af1d0'
    };

    firebase.initializeApp(config);
};

export const askForPermissionToReceiveNotifications = async () => {
    try {
       
        const messaging = firebase.messaging();
        await messaging.requestPermission();
        const token = await messaging.getToken();
        localStorage.setItem('notification-token', token);

        const apiUrl = 'https://webapp.irimo.ir/add.php';

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
    
        const options = {
          method: 'POST',
          body: JSON.stringify({"token":token}),
          myHeaders
        };
    
        fetch(apiUrl, options)
          .then(res => res.json())
          .then(result => {
            console.log('ressss:', result);
          },
          (error) => {
            console.log('ressss:', error);
          }
        )
      
        await messaging().subscribeToTopic('all');
        return token;
    } catch (error) {
        console.log(error);
    }
};
